// Admission lists — the IP module's "Discharged" view and Patient Records →
// Admissions. A discharged admission no longer has a bed on the bed board, so
// these lists are the way back to its (read-only) Case Sheet.
//
// GET /api/ip/admissions is branch-scoped (routes/ip.js): the lists show this
// branch's admissions only.
import { api, type Paged } from '@/lib/api/client';

export interface AdmissionListRow {
  id: number;
  patient_id: number;
  patient_name: string;
  patient_title?: string | null;
  patient_uhid: string;
  gender?: string | null;
  age?: number | null;
  status: 'admitted' | 'discharged' | string;
  ip_number?: string | null;
  admitted_at: string;
  discharged_at?: string | null;
  discharge_type?: string | null;
  admitting_doctor?: string | null;
  provisional_diagnosis?: string | null;
  bed_number: string | number;
  ward_name: string;
  /** Status of the current discharge summary, or null when none was started. */
  discharge_summary_status?: 'draft' | 'signed' | string | null;
  /** Final-profile PDF exports + .docx case sheets filed to Patient Records. */
  case_sheet_count: number;
  case_sheet_last_at?: string | null;
}

export interface AdmissionListQuery {
  status?: 'admitted' | 'discharged';
  patientId?: number;
  /** Name, UHID or IP number. */
  q?: string;
  /** YYYY-MM-DD, hospital timezone; the discharge date when status=discharged. */
  from?: string;
  to?: string;
  page?: number;
  limit?: number;
}

export function fetchAdmissionList(query: AdmissionListQuery): Promise<Paged<AdmissionListRow>> {
  return api.list<AdmissionListRow>('/ip/admissions', { page: query.page, limit: query.limit }, {
    query: {
      status: query.status, patient_id: query.patientId, q: query.q?.trim() || undefined,
      from: query.from, to: query.to,
    },
  });
}
